import type { TOC } from '@ember/component/template-only';
import type { EmberChangeset } from 'ember-changeset';
import Item from 'parog-web/components/multi-steps-edition-form/summary/item';
interface Signature {
  Args: {
    currentSections: string[];
    changeset: EmberChangeset;
    translationPrefix: string;
  };
}

const MiciBaseEditionFormSummaryComponent: TOC<Signature> = <template>
  <div class='text-lg leading-normal'>Veillez à vérifier vos réponses avant de
    valider définitivement le questionnaire.</div>
  <div class='mb-4 flex flex-col gap-4 text-left text-sm'>
    {{#each @currentSections as |section|}}
      <Item
        @changeset={{@changeset}}
        @section={{section}}
        @translationPrefix={{@translationPrefix}}
      />
    {{/each}}
  </div>
</template>;
export default MiciBaseEditionFormSummaryComponent;
